<template>
  <v-expand-transition>
    <slot />
  </v-expand-transition>
</template>
